import DuplicateComponent from './DuplicateComponent';

export default DuplicateComponent;
